export class ContactAdvisor {
  titleAdvisor: string = '';
  nameAdvisor: string = '';
  phoneAdvisor: string = '';
  emailAdvisor: string = '';
} 